<template>
  <div>

    <section class="section is-medium">
      <div class="container">
        <h1 class="title">Create an Additional Account</h1>

          <div class="columns">
              <div class="column is-half">
                <div  class="field">
                  <label class="label" for="name">Name</label>
                  <div class="control">
                    <input
                      v-model="accountName"
                      id="name"
                      name="name"
                      type="text"
                      placeholder="Give your account a name that you remember"
                      class="input"
                      required
                    />
                  </div>
                  <p class="help">
                    Give your account a name you and your team members recognize.
                  </p>
                </div>
              </div>
          </div>
          <h2 class="subtitle">Pick the Plan for the Account</h2>
          <div class="field has-text-centered  ">
            <input id="pricingSwitch" type="checkbox" name="pricingSwitch" class="switch" v-model="yearly">
            <label v-if="yearly" for="pricingSwitch"><b>Yearly Prices</b> <span class="tag mr-4 is-light is-medium is-success"><b>4 months off 🎉</b></span></label>
            <label v-else for="pricingSwitch">Monthly Prices</label>
          </div>
          <div class="columns">
            
            <div class="column is-half">
              <div class="card">
                <div class="card-content">
                  <div class="content">
                    <h2 class="has-text-centered">Professional</h2>
                    <div v-if="yearly" class="plan-price"><span class="plan-price-amount"><span class="plan-price-currency">$</span>13</span>/month <br>billed yearly: $156 </div>
                    <div v-else class="plan-price"><span class="plan-price-amount"><span class="plan-price-currency">$</span>19</span>/month</div>
            
            <ul class="no-bullets">
              <li class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Unlimited surveys</li>
              <li class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Unlimited ratings</li>
              <li class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Unlimited responses</li>
              <li class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> 3 Walls of Love</li>
              <li class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> 23 feedbacks per Wall of Love</li>
              <li class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> 2 Account-seats</li>
                            <li class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Export feedback & newsletter performance</li>
              <li class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Email notifications</li>
              <li class="plan-item"><span class="has-text-danger has-text-weight-bold is-size-5">&times;</span> <del>Webhook notifications</del></li>
              <li class="plan-item"><span class="has-text-danger has-text-weight-bold is-size-5">&times;</span> <del>API</del></li>
            </ul>
                  </div>
                </div>
                  <footer class="card-footer">
                    <a v-if="yearly" class="card-footer-item" @click="buyEarlySupporter">Create Account</a>
                    <a v-else class="card-footer-item" @click="buyEarlySupporterMonthly">Create Account</a>
                </footer>
              </div>
            </div>
            <div class="column is-half">
              <div class="card">
                <div class="card-content">
                  <div class="content">
                    <h2 class="has-text-centered">Business</h2>
                    <div v-if="yearly" class="plan-price"><span class="plan-price-amount"><span class="plan-price-currency">$</span>33</span>/month <br>billed yearly: $392 </div>
                    <div v-else class="plan-price"><span class="plan-price-amount"><span class="plan-price-currency">$</span>49</span>/month</div>
                    <ul class="no-bullets">
                      <li class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Unlimited surveys</li>
                      <li class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Unlimited ratings</li>
                      <li class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Unlimited responses</li>
                      <li class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Unlimited Walls of Love</li>
                      <li class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> 1000 feedbacks per Wall of Love</li>
                      <li class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> 5 Account-seats</li>
                      <li class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Export feedback & newsletter performance</li>
                      <li class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Email notifications</li>
                      <li class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Webhook notifications</li>
                      <li class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> API</li>
                    </ul>
                  </div>
                </div>
                  <footer class="card-footer">
                  <a v-if="yearly" class="card-footer-item" @click="buyBizYearly">Create Account</a>
                  <a v-else class="card-footer-item" @click="buyBizMonthly">Create Account</a>
                </footer>
              </div>
            </div>
          </div>
      </div>
    </section>

  </div>
</template>

<script>
// @ is an alias to /src
import AccountCreateSuccessForm from "@/components/AccountCreateSuccessForm.vue";
import { mapState } from 'vuex'
import {trackEvent}  from "../lib/flevents"

export default {
  name: "AccountCreate",
  components: { },
  data: function () {
    return {
      feedbackForms: [],
      recentFeedback: [],
      searchTerm: null,
      isLoading:false,
      isLoadingRecentFeedback:false,
      yearly: true,
      loggedIn: true,
      accountName: "My new account"
    };
  },
  computed: {
    ...mapState([
      "user",
      "account"
    ]),
    subscribed() {
      return this.account.subscribed;
    },
  },
  mounted: function () {
    if (!this.user.isLoggedIn) {
      this.loggedIn = false
    } else {
      trackEvent(this.$store.state.user.id, "upgrade-view")
    }
    //this.showSuccessModal()
  },
  methods: {
    openBuyOverlay: function(planId, planLabel="Professional") {
        console.log(this.account.id)

        if(!this.loggedIn) {
          this.$buefy.dialog.alert("<p>Please log into your account first. </p><p class='mt-3'>Don't have one?</p><p  class='mt-3'> <a href='/register'>Sign Up for Free Now</a></p>")
          return
        }

        var self = this
        Paddle.Setup({ 
          vendor: 8205,
        });
        let passthrough = "n:"+ this.user.id + ":" + this.accountName
        console.log(passthrough)
        Paddle.Checkout.open({
          product: planId,
          passthrough: passthrough,
          successCallback: function(data) {
            //console.log(data.event); // The data.event will specify the event type
            //console.log(data.eventData); // Data specifics on the event

            self.$store.dispatch('loadAccounts')
              .then((response) => {
                self.showSuccessModal(planLabel)
              })
              .catch((error) => {
                console.log(error)
              });
          }
        });
    },    
    buyBizYearly: function() {
      this.openBuyOverlay(758628, "Business")
    },
    buyBizMonthly: function() {
      this.openBuyOverlay(758627, "Business")
    },
      buyEarlySupporter: function() {
        this.openBuyOverlay(889858)
    },
    showSuccessModal: function(planLabel) {
      this.$buefy.modal.open({
        parent: this,
        component: AccountCreateSuccessForm,
        hasModalCard: false,
        canCancel: true,
        width: 640,
        trapFocus: true,
        props: {
          planLabel: planLabel
        }
      })
    },
    buyEarlySupporterMonthly: function() {
      this.openBuyOverlay(883564)
    },
  },
};
</script>

<style lang="scss" scoped>

.plan-price {
      -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    text-size-adjust: 100%;
    --rem: 16;
    font-family: "Nunito", -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    line-height: 1.5;
    list-style-type: none;
    box-sizing: inherit;
    background-color: white;
    color: hsl(0deg, 0%, 29%);
    font-size: 0.75rem;
    font-weight: 400;
    padding: 0.75em;
    align-content: center;
    text-align: center;
}
.plan-price-amount {
  color: #4bbf73;
      -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    text-size-adjust: 100%;
    --rem: 16;
    font-family: "Nunito", -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    line-height: 1.5;
    list-style-type: none;
    text-align: center;
    box-sizing: inherit;
    font-style: inherit;
    font-size: 2.5rem;
    font-weight: 700;
}

.plan-price-currency {
      -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    text-size-adjust: 100%;
    --rem: 16;
    font-family: "Nunito", -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    line-height: 1.5;
    list-style-type: none;
    text-align: center;
    box-sizing: inherit;
    font-style: inherit;
    vertical-align: super;
    font-size: 1rem !important;
    font-weight: 400 !important;
    color: hsl(0deg, 0%, 29%);
    margin-right: 0.25rem;
}

.no-bullets {
  list-style-type: none;
}

</style>